import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckDouble } from "@fortawesome/free-solid-svg-icons";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import imagegr from "./hardsell-palma-grandia.webp";
import "./GrandiaAvenue.scss";

const GrandiaAvenue = () => {
  const handleConsultationClick = () => {
    const whatsappLink =
      "https://api.whatsapp.com/send/?phone=+6282297791381&text=Halo%20Vania,%20Saya%C2%A0bisa%20minta%20detail%20Katalog,%20Simulasi%20dan%20Promo%20terbaru%20Rumah%20(Palma+Grandia)%20https://marketing-citralandsurabaya.com/&type=phone_number&app_absent=0";
    window.location.href = whatsappLink;
  };
  return (
    <div className="grandiaAvenue">
      <div className=" containerNew3">
        <div className="containercontent">
          <div className="header">
            <h1>
              PROMO NEW LAUNCH <br />
            </h1>
          </div>
          <div className="pointNew3">
            <div className="New3poin">
              <FontAwesomeIcon icon={faCheckDouble} />
              <span style={{ color: "black" }}>&nbsp;&nbsp;Free Biaya KPR</span>
            </div>
            <div className="New3poin">
              <FontAwesomeIcon icon={faCheckDouble} />
              <span style={{ color: "black" }}>&nbsp;&nbsp;Free AJB</span>
            </div>
            <div className="New3poin">
              <FontAwesomeIcon icon={faCheckDouble} />
              <span style={{ color: "black" }}>&nbsp;&nbsp;Free BPHTB</span>
            </div>
            <div className="New3poin">
              <FontAwesomeIcon icon={faCheckDouble} />
              <span style={{ color: "black" }}>&nbsp;&nbsp;Free Canopy</span>
            </div>
            <div className="New3poin">
              <FontAwesomeIcon icon={faCheckDouble} />
              <span style={{ color: "black" }}>
                &nbsp;&nbsp;Free Smarthome System
              </span>
            </div>
            <div className="New3poin">
              <FontAwesomeIcon icon={faCheckDouble} />
              <span style={{ color: "black" }}>
                &nbsp;&nbsp;Free AC tiap Kamar
              </span>
            </div>
            <div className="New3poin">
              <FontAwesomeIcon icon={faCheckDouble} />
              <span style={{ color: "black" }}>
                &nbsp;&nbsp;Free Member Ciputra Arena*
              </span>
            </div>
            <div className="New3poin">
              <FontAwesomeIcon icon={faCheckDouble} />
              <span style={{ color: "black" }}>
                &nbsp;&nbsp;Free Liburan Keluarga
              </span>
            </div>
            <div className="New3poin">
              <FontAwesomeIcon icon={faCheckDouble} />
              <span style={{ color: "black" }}>
                &nbsp;&nbsp;Free Taman Depan
              </span>
            </div>
          </div>
          <div className="disclaimer">*Disclaimer</div>
          <button className="buttonNew3" onClick={handleConsultationClick}>
            <FontAwesomeIcon icon={faWhatsapp} /> Whatsapp
          </button>
        </div>
        <div className="containergambar">
          <img className="New3gambar" src={imagegr} />
        </div>
      </div>
    </div>
  );
};

export default GrandiaAvenue;
